/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consumer_Declaration_Earliest_DateInputs */

const en_consumer_declaration_earliest_date = /** @type {(inputs: Consumer_Declaration_Earliest_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Earliest possible date`)
};

const de_consumer_declaration_earliest_date = /** @type {(inputs: Consumer_Declaration_Earliest_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zum frühestmöglichen Zeitpunkt`)
};

const fr_consumer_declaration_earliest_date = /** @type {(inputs: Consumer_Declaration_Earliest_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À la première date possible`)
};

const es_consumer_declaration_earliest_date = /** @type {(inputs: Consumer_Declaration_Earliest_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En la primera fecha posible`)
};

const it_consumer_declaration_earliest_date = /** @type {(inputs: Consumer_Declaration_Earliest_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alla prima data possibile`)
};

const nl_consumer_declaration_earliest_date = /** @type {(inputs: Consumer_Declaration_Earliest_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op de vroegst mogelijke datum`)
};

const pl_consumer_declaration_earliest_date = /** @type {(inputs: Consumer_Declaration_Earliest_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`W najwcześniejszym możliwym terminie`)
};

const fi_consumer_declaration_earliest_date = /** @type {(inputs: Consumer_Declaration_Earliest_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aikaisimpana mahdollisena päivänä`)
};

const da_consumer_declaration_earliest_date = /** @type {(inputs: Consumer_Declaration_Earliest_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`På den tidligst mulige dato`)
};

const sv_consumer_declaration_earliest_date = /** @type {(inputs: Consumer_Declaration_Earliest_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`På tidigast möjliga datum`)
};

/**
* | output |
* | --- |
* | "Earliest possible date" |
*
* @param {Consumer_Declaration_Earliest_DateInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const consumer_declaration_earliest_date = /** @type {((inputs?: Consumer_Declaration_Earliest_DateInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consumer_Declaration_Earliest_DateInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_consumer_declaration_earliest_date(inputs)
	if (locale === "fr") return fr_consumer_declaration_earliest_date(inputs)
	if (locale === "es") return es_consumer_declaration_earliest_date(inputs)
	if (locale === "it") return it_consumer_declaration_earliest_date(inputs)
	if (locale === "nl") return nl_consumer_declaration_earliest_date(inputs)
	if (locale === "pl") return pl_consumer_declaration_earliest_date(inputs)
	if (locale === "fi") return fi_consumer_declaration_earliest_date(inputs)
	if (locale === "da") return da_consumer_declaration_earliest_date(inputs)
	if (locale === "sv") return sv_consumer_declaration_earliest_date(inputs)
	return en_consumer_declaration_earliest_date(inputs)
});